<template>
  <b-dropdown
    toggle-class="dropdown-field d-flex flex-column align-items-center border-0 w-100"
    menu-class="menu-shadow dropdown-menu"
    id="dropdown-left"
    variant="default"
    class="m-0"
    boundary="viewport"
    :lazy="true"
    no-caret
  >
    <template v-slot:button-content>
      <component
        class="mw-100"
        :is="selectedOption.name ? 'with-close-icon' : 'div'"
        icon-alignment="top"
        :show-shadow-on-icon="true"
        @close="onDropdownItemClick(null)"
      >
        <div class="d-flex">
          <span
            class="badge py-1 px-2 font-weight-normal w-100 text-truncate text-prime"
            :title="selectedOption.name"
            :style="{ backgroundColor: toHex(selectedOption.color) }"
            v-if="selectedOption.name"
            >{{ selectedOption.name }}</span
          >
          <span class="text-small text-secondary dd-placeholder" v-else>Select</span>
        </div>
      </component>
    </template>
    <b-dropdown-item
      v-for="option in field.dropdownOptions"
      :key="option.id"
      @click="onDropdownItemClick(option.id)"
    >
      <cf-dropdown-option :option="option" :hide-color="hideOptionColor" />
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import CfDropdownOption from '@/components/initiative/CfDropdownOption'
import WithCloseIcon from '@/components/WithCloseIcon'
import { NO_COLOR } from '@/constants/common'
import { BDropdownItem, BDropdown } from 'bootstrap-vue'
import getHexColorValueFromCode from '@/utils/initiative/getHexColorValueFromCode'

export default {
  name: 'InitiativeDropdownField',
  props: ['field', 'selected'],
  components: {
    BDropdownItem,
    BDropdown,
    WithCloseIcon,
    CfDropdownOption
  },
  computed: {
    selectedOption() {
      if (!this.selected) return {}
      return this.field.dropdownOptions.find(option => option.id === this.selected)
    },
    hideOptionColor() {
      return this.field.dropdownOptions.every(option => option.color === NO_COLOR)
    }
  },
  methods: {
    toHex(color) {
      return color !== NO_COLOR ? getHexColorValueFromCode(color) : null
    },
    onDropdownItemClick(id) {
      this.$emit('select', id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/badge';

.dd-placeholder {
  padding-top: 1px;
  opacity: 0;
  transition: opacity ease-in 200ms;
}
/deep/ .dropdown-field:hover .dd-placeholder {
  opacity: 1;
}
.dropdown-menu {
  @include scrollbarWidth($scrollSecondary);

  max-height: 70vh;
  overflow: auto;
}
</style>
